import { createSettingsParams, SettingsParamType } from '@wix/tpa-settings';
import { DataType } from '@wix/editor-platform-ooi-metadata-resolver';

export const emptyStates = {
  blank: 'ratings-settings.empty-state-label.blank',
  plainText: 'ratings-settings.empty-state-label.plain-text',
} as const;

export type EmptyState = keyof typeof emptyStates;

export type SettingsParamsTypes = {
  emptyState: SettingsParamType.Text;
};

export type SettingsParams = typeof settingsParams;

const settingsParams = createSettingsParams<SettingsParamsTypes>({
  emptyState: {
    type: SettingsParamType.Text,
    getDefaultValue: ({ t }): EmptyState => 'blank',
    metadata: {
      type: DataType.textEnum,
      defaultValue: { type: 'static', value: 'blank' },
      ai: {
        description: `
        What to display when the item has no reviews yet.
        Possible values:
        - blank Nothing is shown.
        - plainText A plain text message is shown.
        `,
      },
    },
  },
});
export default settingsParams;
